import { Tag } from 'antd';

 export const FormDescription = ({ description }) => { 
    console.log(description);
    if (!description || description === '') return null; 
    
    return ( 
        <Tag color="blue">
            {description}
        </Tag> ); 

};